import { render, staticRenderFns } from "./historyClassroom.vue?vue&type=template&id=67eda9c8&scoped=true"
import script from "./historyClassroom.vue?vue&type=script&lang=js"
export * from "./historyClassroom.vue?vue&type=script&lang=js"
import style0 from "./historyClassroom.vue?vue&type=style&index=0&id=67eda9c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67eda9c8",
  null
  
)

export default component.exports